import cake1 from "../assets/images/Cakes/cake1.webp";
import cake2 from "../assets/images/Cakes/cake2.webp";
import strawberryBliss from "../assets/images/Cakes/StrawberryBliss.webp";
import cake4 from "../assets/images/Cakes/cake4.webp";
import chocoVanila from "../assets/images/Cakes/ChocoVanila.webp";
import whiteForest from "../assets/images/Cakes/WhiteForest.webp";
import chocoDelight from "../assets/images/Cakes/ChocoDelight.webp";
import chocoRed from "../assets/images/Cakes/ChocoRed.webp";
import vancho from "../assets/images/Cakes/Vancho.webp";
import honeyAlmond from "../assets/images/Cakes/HoneyAlmond.webp";
import whiteFudge from "../assets/images/Cakes/WhiteFudge.webp";
import spanishDelight from "../assets/images/Cakes/SpanishDelight.webp";
import chocoVelvet from "../assets/images/Cakes/ChocoVelvet.webp";
import milkChocolate from "../assets/images/Cakes/MilkChocolate.webp";
import germanChoco from "../assets/images/Cakes/GermanChoco.webp";
import whiteTruffle from "../assets/images/Cakes/WhiteTruffle.webp";
import redVelvet from "../assets/images/Cakes/RedVelvet.webp";
import nuttyBubble from "../assets/images/Cakes/NuttyBubbly.webp";
import blackForest from "../assets/images/Cakes/BlackForest.webp";
import mangoCake from "../assets/images/Cakes/MangoCake.webp";

const cakes = [
  {
    id: 1,
    name: "Chocolate Delight",
    category: "Chocolate",
    price: 1999,
    image: cake1,
    description:
      "Rich and moist chocolate cake layered with smooth chocolate ganache.",
    ingredients: ["Fresh cream", "Butter", "Eggs", "Sugar"],
  },
  {
    id: 2,
    name: "Classic Cream Cake",
    category: "Classic",
    price: 1999,
    image: cake2,
    description:
      "A timeless vanilla sponge cake topped with fresh cream and floral decor.",
    ingredients: [
      "Vanilla essence",
      "Fresh cream",
      "Butter",
      "Eggs",
      "Sugar",
      "Flour",
    ],
  },
  {
    id: 3,
    name: "Strawberry Bliss",
    category: "Fruit",
    price: 1199,
    image: strawberryBliss,
    description:
      "Light vanilla sponge layered with fresh strawberries and whipped cream.",
    ingredients: [
      "Fresh strawberries",
      "Whipped cream",
      "Vanilla sponge",
      "Butter",
      "Sugar",
      "Flour",
    ],
  },
  {
    id: 4,
    name: "Caramel Crunch",
    category: "Caramel",
    price: 750,
    image: cake4,
    description:
      "Soft caramel sponge topped with salted caramel drizzle and crunchy nuts.",
    ingredients: [
      "Caramel sauce",
      "Salted butter",
      "Roasted nuts",
      "Fresh cream",
      "Eggs",
      "Sugar",
    ],
  },
  {
    id: 5,
    name: "Choco Vanila",
    category: "Chocolate",
    price: 900,
    image: chocoVanila,
    description:
      "A delightful fusion of rich chocolate and smooth vanilla flavors.",
    ingredients: ["Dark Chocolate", "Vanilla", "Almonds", "Dry Fruits"],
  },
  {
    id: 6,
    name: "Choco Velvet",
    category: "Chocolate",
    price: 750,
    image: chocoVelvet,
    description:
      "Rich and moist chocolate velvet sponge layered with smooth chocolate cream.",
    ingredients: ["Cocoa powder", "Dark chocolate", "Fresh cream"],
  },

  // 🔥 Newly Added Cakes

  {
    id: 7,
    name: "White Forest",
    category: "Classic",
    price: 499,
    image: whiteForest,
    description:
      "Soft vanilla sponge layered with white cream and chocolate flakes.",
    ingredients: ["Vanilla sponge", "Fresh cream", "White chocolate", "Sugar"],
  },
  {
    id: 8,
    name: "Choco Delight",
    category: "Chocolate",
    price: 750,
    image: chocoDelight,
    description:
      "Delicious chocolate sponge layered with creamy chocolate frosting.",
    ingredients: ["Cocoa powder", "Chocolate cream", "Butter", "Eggs"],
  },
  {
    id: 9,
    name: "Vancho",
    category: "Chocolate",
    price: 750,
    image: vancho,
    description:
      "A perfect blend of vanilla and chocolate sponge with rich frosting.",
    ingredients: ["Vanilla sponge", "Chocolate sponge", "Fresh cream", "Sugar"],
  },
  {
    id: 10,
    name: "Honey Almond",
    category: "Classic",
    price: 900,
    image: honeyAlmond,
    description:
      "Soft honey-flavored sponge topped with roasted almonds and cream.",
    ingredients: ["Honey", "Almonds", "Fresh cream", "Butter", "Flour"],
  },
  {
    id: 11,
    name: "White Fudge",
    category: "Chocolate",
    price: 750,
    image: whiteFudge,
    description:
      "Creamy white chocolate fudge cake with smooth velvety texture.",
    ingredients: ["White chocolate", "Fresh cream", "Butter", "Sugar"],
  },
  {
    id: 12,
    name: "Spanish Delight",
    category: "Classic",
    price: 960,
    image: spanishDelight,
    description: "Rich caramelized sponge layered with silky cream and nuts.",
    ingredients: ["Caramel sauce", "Fresh cream", "Almonds", "Butter"],
  },
  {
    id: 13,
    name: "Choco Red",
    category: "Chocolate",
    price: 750,
    image: chocoRed,
    description:
      "Red velvet sponge infused with chocolate flavor and creamy frosting.",
    ingredients: ["Cocoa powder", "Red velvet sponge", "Cream cheese", "Sugar"],
  },
  {
    id: 14,
    name: "Milk Chocolate",
    category: "Chocolate",
    price: 900,
    image: milkChocolate,
    description:
      "Smooth and creamy milk chocolate cake with rich chocolate layers.",
    ingredients: ["Milk chocolate", "Fresh cream", "Butter", "Eggs"],
  },
  {
    id: 15,
    name: "German Choco",
    category: "Chocolate",
    price: 750,
    image: germanChoco,
    description:
      "Classic German chocolate cake topped with coconut pecan frosting.",
    ingredients: ["Dark chocolate", "Coconut", "Pecans", "Butter", "Sugar"],
  },
  {
    id: 16,
    name: "White Truffle",
    category: "Chocolate",
    price: 750,
    image: whiteTruffle,
    description:
      "Elegant white chocolate truffle cake with smooth creamy finish.",
    ingredients: ["White chocolate", "Fresh cream", "Butter", "Sugar"],
  },
  {
    id: 17,
    name: "Red Velvet",
    category: "Classic",
    price: 750,
    image: redVelvet,
    description:
      "Soft and moist red velvet sponge layered with cream cheese frosting.",
    ingredients: ["Cocoa powder", "Cream cheese", "Butter", "Sugar", "Flour"],
  },
  {
    id: 18,
    name: "Nutty Bubble",
    category: "Chocolate",
    price: 900,
    image: nuttyBubble,
    description:
      "Chocolate sponge topped with crunchy nuts and bubble chocolate pieces.",
    ingredients: ["Dark chocolate", "Mixed nuts", "Fresh cream", "Butter"],
  },
  {
    id: 19,
    name: "Black Forest",
    category: "Classic",
    price: 499,
    image: blackForest,
    description:
      "Classic chocolate sponge layered with fresh cream and juicy cherries, topped with chocolate shavings.",
    ingredients: [
      "Chocolate sponge",
      "Fresh cream",
      "Cherries",
      "Chocolate flakes",
      "Sugar",
    ],
  },
  {
    id: 20,
    name: "Mango Delight",
    category: "Fruit",
    price: 790,
    image: mangoCake,
    description:
      "Soft vanilla sponge layered with fresh mango pulp and whipped cream, topped with juicy mango slices.",
    ingredients: [
      "Fresh mango pulp",
      "Whipped cream",
      "Vanilla sponge",
      "Sugar",
      "Butter",
    ],
  },
];
export default cakes;
